module.exports = __webpack_public_path__ + "img/ios1.6ee381e1.png";